<template>
  <div
    v-if="showAgenticBreadcrumbHomeOnly"
    class="v-breadcrumbs agentic-breadcrumb-home-only"
    :class="{ 'dark-mode': isDarkMode }"
  >
    <router-link
      :to="{ name: 'AgenticDashboard' }"
      class="home-img agentic-breadcrumb-home-link"
      title="Home"
      aria-label="Agentic Dashboard home"
    >
      <v-img
        src="../../../assets/Images/House.png"
        width="20"
        height="20"
        alt=""
        class="cursor-pointer"
      />
    </router-link>
  </div>
  <v-breadcrumbs v-else-if="!hideBreadcrumbs" :items="breadcrumbItems" :class="{ 'dark-mode': isDarkMode }">
    <template v-slot:divider>
      <div class="divider-img">
        <v-img src="../../../assets/Images/breadcrumb-right-con.png" width="6" height="11"></v-img>
      </div>
    </template>
    <template v-slot:prepend>
      <div class="home-img">
        <v-img src="../../../assets/Images/House.png" class="cursor-pointer" width="20" height="20"
          @click="goToAssets"></v-img>
      </div>
      <div class="divider-img" v-if="isAssetsRoute">
        <v-img src="../../../assets/Images/breadcrumb-right-con.png" width="6" height="11"></v-img>
      </div>
    </template>
    <template v-slot:item="{ item, index }">
      <div class="text-capitalize test-text d-flex align-end"
        v-if="index === breadcrumbItems.length - 1 && !showTestsDropdown && item.isTestType">
        {{ item.title }}
        <v-icon width="16" height="16" @click="toggleTestsDropdown">mdi-chevron-down</v-icon>
      </div>
      <div class="text-capitalize test-text" v-else-if="showTestsDropdown && item.isTestType" ref="dropdownMenu">
        {{ item.title }}
        <v-icon width="16" height="16" @click="toggleTestsDropdown">mdi-chevron-up</v-icon>
        <div class="dropdown-menu">
          <div class="test-name-div" v-if="isTestAvailable">
            <div class="breadcrumb-test-name" @click="openSampleValidationPage">
              Sample Validation
            </div>
          </div>
          <div class="test-name-div" v-for="(test, listIndex) in allTests" :key="`test-${listIndex}-${test?.ID || test?.id || listIndex}`">
            <div class="breadcrumb-test-name" @click="openTestPage(test, listIndex)"
              :class="{ 'active': activeTestIndex === listIndex }">
              <template v-if="getTestType(test) === 'compositiontests'">
                <template v-if="test.contaminationType || test.recombinationType">
                  {{ getTestDisplayName(getTestType(test), test) }}({{ test.contaminationType ? test.contaminationType.charAt(0).toUpperCase() + test.contaminationType.slice(1) : '' }}{{ test.recombinationType ? ' ' + test.recombinationType.charAt(0).toUpperCase() + test.recombinationType.slice(1) : '' }})
                </template>
                <template v-else>{{ getTestDisplayName(getTestType(test), test) }}</template>
              </template>
              <template v-else>
                {{ getTestDisplayName(getTestType(test), test)}}
                <template v-if="test.testTemperature || test.testTemperature_UOM">
                  ({{ test.testTemperature }} {{ test.testTemperature_UOM }})
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div
        class="text-capitalize"
        v-else
        @click.native="isNonNavBreadcrumbItem(item) ? null : handleBreadcrumb(item.title)"
      >
        <router-link v-if="!isNonNavBreadcrumbItem(item)" :to="{ path: item.href }">
          {{ item.title }}
        </router-link>
        <span v-else>
          {{ item.title }}
        </span>
      </div>
    </template>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout">
      {{ snackbar.message }}
    </v-snackbar>
  </v-breadcrumbs>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from 'vuex';
import { getTenantPrefix } from "@/utils/tenant";
import { pickSamplesListQueryForRouter } from "@/components/layout/QAQC/Overview/qaqcSamplesListQuery.js";
import {
  mergeOverviewTabIntoQuery,
  overviewTabFromTestRoute,
} from "@/components/layout/QAQC/Overview/qaqcOverviewTab.js";
export default {
  name: "Links",
  data: () => ({
    items: [],
    currentURLSegments: [],
    showTestsDropdown: false,
    allTests: [],
    isTestAvailable: false,
    currentSampleId: null,
    isLoadingTests: false,
    qaqcBreadcrumbSampleMeta: null,
    qaqcBreadcrumbMetaSampleId: null,
    isLoadingQaqcBreadcrumbMeta: false,
    snackbar: {
      visible: false,
      message: "",
      color: "success",
      timeout: 3000,
    },
  }),
  computed: {
    ...mapGetters("test", ['activeTestIndex']),
    ...mapGetters("darkMode", ["isDarkMode"]),
    isAssetsRoute() {
      return this.$route.name !== 'Assets' && this.$route.name !== 'DataManagement' && this.$route.name !== 'FluidsDataStudio' && this.$route.name !== 'Main';
    },
    isAgenticHomeScreen() {
      return (
        this.$route.name === "AgenticDashboard" &&
        !this.$route.params.dashboardName &&
        !this.$route.params.dashboardId
      );
    },
    showAgenticBreadcrumbHomeOnly() {
      if (this.hideBreadcrumbs) {
        return false;
      }
      return this.$route.name === "AgenticDashboardView";
    },
    hideBreadcrumbs() {
      const pathSegments = this.$route.path.split('/').filter(Boolean);
      if (pathSegments.length < 2) return false;

      const routePath = `/${pathSegments.slice(1).join('/')}`.toLowerCase();

      const isAgenticListHub =
        this.$route.name === "AgenticDashboardAll" ||
        this.$route.name === "AgenticDashboardStarred" ||
        this.$route.name === "AgenticDashboardShared";

      return (
        routePath.includes("/exploratory-data-analysis") ||
        routePath.includes("/pvt-prediction") ||
        routePath.includes("/dashboards") ||
        routePath.includes("/fluidsdata-studio") ||
        routePath.includes("/roles") ||
        routePath.includes("/users") ||
        routePath.includes("/fluidsintelligence") ||
        (routePath.includes("/agentic-dashboard") && this.isAgenticHomeScreen) ||
        isAgenticListHub
      );
    },

    breadcrumbItems() {
      const itemsCopy = this.items.slice();
      const pathSegments = this.$route.path.split('/').filter(Boolean);
      if (pathSegments.length < 2) return [];

      const tenantId = pathSegments[0];
      const filteredSegments = pathSegments.slice(1);

      const assetParam = this.$route.params.asset;
      const fieldParam = this.$route.params.field;
      const wellParam = this.$route.params.well;
      const currentRoute = `/${filteredSegments.join('/')}`;

      if (currentRoute.startsWith("/agentic-dashboard")) {
        return [];
      }

      if (currentRoute.includes("/qaqc")) {
        const testType = this.$route.params.testType;
        const testId = this.$route.params.testId;
        const routeQaqcSampleId = this.$route.params.sampleId;
        const isQaqcOverviewRoute = currentRoute.includes("/qaqc/overview");
        const onQaqcDetail = currentRoute.includes("/qaqc/detail");
        const onQaqcTest = currentRoute.includes("/qaqc/test");
        const qaqcDetailBreadcrumbTitle = this.buildQaqcDetailBreadcrumbTitle(this.$route);
        const qaqcDetailHref = this.qaqcDetailHrefFromRoute(this.$route, tenantId);

        if (!isQaqcOverviewRoute && !onQaqcDetail && !onQaqcTest) {
          itemsCopy.push({
            title: "QA/QC",
            href: `/${tenantId}/qaqc`
          });
        }

        if (onQaqcDetail) {
          itemsCopy.push({
            title: qaqcDetailBreadcrumbTitle,
            href: qaqcDetailHref
          });
        } else if (testType) {
          const listQ = pickSamplesListQueryForRouter(this.$route.query || {});
          const testDisplayTitle = this.formatQaqcTestBreadcrumbTitle(
            this.buildQaqcTestBreadcrumbTitle(testType, testId)
          );
          const testPath =
            testId && routeQaqcSampleId
              ? `/${tenantId}/qaqc/test/${routeQaqcSampleId}/${testType}/${testId}`
              : qaqcDetailHref;
          const testHrefWithQuery = testPath.includes("/qaqc/test")
            ? this.appendRouteQuery(testPath, listQ)
            : testPath;
          const contextItems = this.buildQaqcTestRouteContextItems(this.$route, tenantId);

          itemsCopy.push(
            ...contextItems,
            {
              title: testDisplayTitle,
              href: testHrefWithQuery,
              isTestType: true,
            }
          );
        }
      }
      else if (
        currentRoute.includes("/compositiontests") ||
        currentRoute.includes("/dltest") ||
        currentRoute.includes("/ccetest") ||
        currentRoute.includes("/cvdtest") ||
        currentRoute.includes("/separatortest") ||
        currentRoute.includes("/viscositytest") ||
        currentRoute.includes("/samplevalidation") ||
        currentRoute.includes("/sampleinformation")
        ) {
          const assetsTestMatch = currentRoute.match(/\/(compositiontests|dltest|ccetest|cvdtest|separatortest|viscositytest)\/([^/]+)$/);
          const routeTestSegment = assetsTestMatch ? assetsTestMatch[1] : null;
          const routeTestId = assetsTestMatch ? assetsTestMatch[2] : null;
          const sampleIdParam = this.$route.params.sampleId;
          const samplesPageHref = `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}`;

          itemsCopy.push(
            {
              title: assetParam ? `Asset: ${assetParam.replace(/\//g, '-').replace(/ /g, '-')}` : "Assets",
              href: `/${tenantId}/assets/${assetParam || ''}`
            },
            {
              title: fieldParam ? `Field: ${fieldParam.replace(/\//g, '-').replace(/ /g, '-')}` : "Fields",
              href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}`
            },
            {
              title: wellParam ? `Well: ${wellParam.replace(/\//g, '-').replace(/ /g, '-')}` : "Wells",
              href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}`
            },
            {
              title: "Samples",
              href: samplesPageHref
            }
          );

          if (routeTestSegment && routeTestId) {
            const normalizedTestType = routeTestSegment === 'compositiontests' ? 'compositiontests' : routeTestSegment + 's';
            let testDisplayTitle = this.displayTestType(normalizedTestType);
            if (this.allTests && this.allTests.length > 0) {
              const currentTest = this.allTests.find(test => {
                const testTestType = test.testType || test.TestType || test.test_type;
                const testTypeMatch = testTestType === normalizedTestType || testTestType === routeTestSegment;
                const idMatch = (test.ID || test.id || test.testId) === routeTestId || (test.ID || test.id || test.testId) === String(routeTestId);
                return testTypeMatch && idMatch;
              });
              if (currentTest) {
                if (this.getTestType(currentTest) === 'compositiontests') {
                  if (currentTest.contaminationType || currentTest.recombinationType) {
                    testDisplayTitle = `${this.getTestDisplayName(this.getTestType(currentTest), currentTest)}(${currentTest.contaminationType ? currentTest.contaminationType.charAt(0).toUpperCase() + currentTest.contaminationType.slice(1) : ''}${currentTest.recombinationType ? ' ' + currentTest.recombinationType.charAt(0).toUpperCase() + currentTest.recombinationType.slice(1) : ''})`;
                  } else {
                    testDisplayTitle = this.getTestDisplayName(this.getTestType(currentTest), currentTest);
                  }
                } else {
                  testDisplayTitle = this.getTestDisplayName(this.getTestType(currentTest), currentTest);
                  if (currentTest.testTemperature || currentTest.testTemperature_UOM) {
                    testDisplayTitle += ` (${currentTest.testTemperature} ${currentTest.testTemperature_UOM || ''})`.trim();
                  }
                }
              }
            }
            const currentTestHref = sampleIdParam
              ? `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}/${sampleIdParam}/${routeTestSegment}/${routeTestId}`
              : `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}/${routeTestSegment}/${routeTestId}`;
            itemsCopy.push({
              title: testDisplayTitle,
              href: currentTestHref,
              isTestType: true
            });
          } else {
            itemsCopy.push({
              title: "Tests",
              href: samplesPageHref
            });
          }
        } else if (wellParam) {
          itemsCopy.push(
            { title: `Asset: ${assetParam || "Assets"}`, href: `/${tenantId}/assets/${assetParam || ''}` },
            { title: `Field: ${fieldParam}`, href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}` },
            { title: `Well: ${wellParam}`, href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}` }
          );
        } else if (fieldParam) {
          itemsCopy.push(
            { title: `Asset: ${assetParam || "Assets"}`, href: `/${tenantId}/assets/${assetParam || ''}` },
            { title: `Field: ${fieldParam}`, href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}` }
          );
        } else if (assetParam) {
          itemsCopy.push(
            { title: `Asset: ${assetParam || "Assets"}`, href: `/${tenantId}/assets/${assetParam || ''}` }
          );
        } else {
          let currentPath = `/${tenantId}`;
          const edaBase = `/${tenantId}/exploratory-data-analysis`;
          itemsCopy.push(
            ...filteredSegments
              .filter(segment => !["assets", "data-management", "dashboards", "fluidsdata-studio"].includes(segment.toLowerCase())) 
              .map(segment => {
                currentPath += `/${segment.replace(/\//g, '-').replace(/ /g, '-')}`;
                const segLower = segment.toLowerCase();
                let title = segment.replace(/-/g, ' ').charAt(0).toUpperCase() + segment.replace(/-/g, ' ').slice(1);

                if (segLower === "exploratory-data-analysis") {
                  title = "Exploratory Data Analysis (EDA)";
                } else if (segLower === "inventory-analysis") {
                  title = "Inventory Analysis";
                } else if (segLower === "twodhistogram-kde") {
                  title = "2D Histogram and Bivariate KDE";
                } else if (segLower === "correlation-analysis") {
                  title = "Correlation Analysis";
                } else if (segLower === "statistical-analysis") {
                  title = "Statistical Analysis";
                } else if (segLower === "3d-plot-analysis") {
                  title = "3D Plot Analysis";
                } else if (segLower === "bubble-plot-analysis") {
                  title = "Bubble Plot Analysis";
                } else if (segLower === "heatmap-analysis") {
                  title = "Heatmap Analysis";
                } else if (segLower === "composition-gradient-analysis") {
                  title = "Composition Gradient Analysis";
                } else if(title === "Qaqc" || title === "qaqc" || title === "QA QC")
                {
                  title = "QA/QC";
                }
                else if(currentRoute.includes("/qaqc/data-validation") && title !== "QA/QC") 
                {
                  title = "Data Validation";
                }
                else if(currentRoute.includes("/qaqc/quality-metrics") && title !== "QA/QC")
                {
                  title = "Quality Metrics";
                }
                else if(currentRoute.includes("/qaqc/compliance-check") && title !== "QA/QC")
                {
                  title = "Compliance Check";
                }
                else if(currentRoute.includes("/qaqc/qaqc-wells") && title !== "QA/QC")
                {
                  title = "Wells Overview";
                }
                else if(currentRoute.includes("/qaqc/detail") && title !== "QA/QC")
                {
                  title = "Detail";
                }

                let href = currentPath;
                if (href === edaBase) {
                  href = `${edaBase}/inventory-analysis`;
                }

                return {
                  title,
                  href,
                  icon: "mdi-chevron-down"
                };
              })
          );
        }
        return itemsCopy;
    },
    displayTestType() {
      return function (testType) {
        switch (testType) {
          case 'compositiontests':
            return 'Composition';
          case 'dltests':
          case 'dltest':
            return 'DL Test';
          case 'ccetests':
          case 'ccetest':
            return 'CCE Test';
          case 'cvdtests':
          case 'cvdtest':
            return 'CVD Test';
          case 'separatortests':
          case 'separatortest':
            return 'Separator Test';
          case 'viscositytests':
          case 'viscositytest':
            return 'Viscosity Test';
          default:
            return testType;
        }
      }
    },
  },
  methods: {
    ...mapActions("test", ['setActiveTestIndex']),
    appendRouteQuery(path, query) {
      if (!query || typeof query !== "object") return path;
      const sp = new URLSearchParams();
      Object.keys(query).forEach((k) => {
        const v = query[k];
        if (v == null || v === "") return;
        const val = Array.isArray(v) ? v[0] : v;
        if (val != null && String(val) !== "") sp.set(k, String(val));
      });
      const s = sp.toString();
      return s ? `${path}?${s}` : path;
    },
    qaqcDetailHrefFromRoute(route, tenantId) {
      const r = route || this.$route;
      const p = r.params || {};
      const w = p.well;
      if (w == null || String(w).trim() === "") {
        return `/${tenantId}/qaqc/detail`;
      }
      const wellSeg = encodeURIComponent(String(w));
      const base = `/${tenantId}/qaqc/detail/${wellSeg}`;
      let path = base;
      if (r.name === "QAQCDetailSample" && p.sampleId != null && p.fluidSampleID != null) {
        path = `${base}/sample/${encodeURIComponent(String(p.sampleId))}/${encodeURIComponent(String(p.fluidSampleID))}`;
      } else if (r.name === "QAQCDetailReport" && p.sampleId != null && p.reportIdentifier != null) {
        path = `${base}/report/${encodeURIComponent(String(p.sampleId))}/${encodeURIComponent(String(p.reportIdentifier))}`;
      }
      return this.appendRouteQuery(path, pickSamplesListQueryForRouter(r.query || {}));
    },
    decodeQaqcRouteParam(val) {
      if (val == null || String(val).trim() === "") return "";
      try {
        return decodeURIComponent(String(val));
      } catch {
        return String(val);
      }
    },
    parseQaqcWellFromRoute(route) {
      const r = route || this.$route;
      const raw = r.params?.well;
      if (raw != null && String(raw).trim() !== "") {
        return this.decodeQaqcRouteParam(raw);
      }
      const q = r.query?.well;
      if (q != null && String(q).trim() !== "") {
        return String(q);
      }
      return "";
    },
    buildQaqcDetailBreadcrumbTitle(route) {
      const r = route || this.$route;
      const name = r.name;
      const p = r.params || {};
      const q = r.query || {};
      const well = this.parseQaqcWellFromRoute(r);
      const wellLabel = well ? `Well: ${well}` : "";

      if (name === "QAQCDetailReport") {
        const rep = p.reportIdentifier != null ? this.decodeQaqcRouteParam(p.reportIdentifier) : "";
        return rep ? `Report: ${rep}` : "Report";
      }
      if (name === "QAQCDetailSample") {
        const fluid = p.fluidSampleID != null ? this.decodeQaqcRouteParam(p.fluidSampleID) : "";
        const sid = p.sampleId != null ? this.decodeQaqcRouteParam(p.sampleId) : "";
        const idPart = fluid || sid;
        return idPart ? `Sample: ${idPart}` : "Sample";
      }
      if (q.reportIdentifier != null && String(q.reportIdentifier).trim() !== "") {
        const rep = this.decodeQaqcRouteParam(q.reportIdentifier);
        return `Report: ${rep}`;
      }
      const hasFluid = q.fluidSampleID != null && String(q.fluidSampleID).trim() !== "";
      const hasSampleId = q.sampleId != null && String(q.sampleId).trim() !== "";
      if (hasFluid || hasSampleId) {
        const idPart = hasFluid ? String(q.fluidSampleID) : String(q.sampleId);
        return idPart ? `Sample: ${idPart}` : "Sample";
      }
      return wellLabel || "Well";
    },
    parseQaqcFluidSampleIdFromRoute(route) {
      const r = route || this.$route;
      if (r.params?.fluidSampleID != null && String(r.params.fluidSampleID).trim() !== "") {
        return this.decodeQaqcRouteParam(r.params.fluidSampleID);
      }
      const q = r.query?.fluidSampleID;
      if (q != null && String(q).trim() !== "") {
        return String(q);
      }
      return "";
    },
    parseQaqcReportIdentifierFromRoute(route) {
      const r = route || this.$route;
      if (r.params?.reportIdentifier != null && String(r.params.reportIdentifier).trim() !== "") {
        return this.decodeQaqcRouteParam(r.params.reportIdentifier);
      }
      const q = r.query?.reportIdentifier;
      if (q != null && String(q).trim() !== "") {
        return this.decodeQaqcRouteParam(q);
      }
      return "";
    },
    buildQaqcSampleDetailHref(route, tenantId) {
      const r = route || this.$route;
      const well = this.parseQaqcWellFromRoute(r);
      const fluid = this.parseQaqcFluidSampleIdFromRoute(r);
      const mongoId = r.params?.sampleId;
      const listQ = pickSamplesListQueryForRouter(r.query || {});
      if (well && mongoId && fluid) {
        const path = `/${tenantId}/qaqc/detail/${encodeURIComponent(well)}/sample/${encodeURIComponent(String(mongoId))}/${encodeURIComponent(fluid)}`;
        return this.appendRouteQuery(path, listQ);
      }
      if (well) {
        return this.appendRouteQuery(`/${tenantId}/qaqc/detail/${encodeURIComponent(well)}`, listQ);
      }
      return this.appendRouteQuery(`/${tenantId}/qaqc/detail`, listQ);
    },
    buildQaqcReportDetailHref(route, tenantId) {
      const r = route || this.$route;
      const well = this.parseQaqcWellFromRoute(r);
      const reportId = this.parseQaqcReportIdentifierFromRoute(r);
      const mongoId = r.query?.sampleId || r.params?.sampleId;
      const listQ = pickSamplesListQueryForRouter(r.query || {});
      if (well && mongoId && reportId) {
        const path = `/${tenantId}/qaqc/detail/${encodeURIComponent(well)}/report/${encodeURIComponent(String(mongoId))}/${encodeURIComponent(reportId)}`;
        return this.appendRouteQuery(path, listQ);
      }
      if (well) {
        return this.appendRouteQuery(`/${tenantId}/qaqc/detail/${encodeURIComponent(well)}`, {
          ...listQ,
          reportIdentifier: reportId,
        });
      }
      return this.appendRouteQuery(`/${tenantId}/qaqc/detail`, listQ);
    },
    parseQaqcNavContext(route) {
      const q = route?.query?.qaqcCtx;
      const v = q != null ? String(q).toLowerCase().trim() : "";
      if (v === "well" || v === "report" || v === "sample" || v === "direct") {
        return v;
      }
      return "direct";
    },
    resolveQaqcBreadcrumbFields(route) {
      const r = route || this.$route;
      let well = this.parseQaqcWellFromRoute(r);
      let fluidSampleId = this.parseQaqcFluidSampleIdFromRoute(r);
      const reportId = this.parseQaqcReportIdentifierFromRoute(r);
      const meta = this.qaqcBreadcrumbSampleMeta;
      if (meta) {
        if (!well && meta.well) well = meta.well;
        if (!fluidSampleId && meta.fluidSampleID) fluidSampleId = meta.fluidSampleID;
      }
      return { well, fluidSampleId, reportId };
    },
    buildQaqcTestRouteContextItems(route, tenantId) {
      const r = route || this.$route;
      const ctx = this.parseQaqcNavContext(r);
      const listQ = pickSamplesListQueryForRouter(r.query || {});
      const { well, fluidSampleId, reportId } = this.resolveQaqcBreadcrumbFields(r);
      const items = [];

      const pushSample = () => {
        if (!fluidSampleId) return;
        items.push({
          title: `Sample: ${fluidSampleId}`,
          href: this.buildQaqcSampleDetailHref(r, tenantId),
        });
      };

      if (ctx === "sample") {
        pushSample();
        return items;
      }

      if (ctx === "report") {
        if (reportId) {
          items.push({
            title: `Report: ${reportId}`,
            href: this.buildQaqcReportDetailHref(r, tenantId),
          });
        }
        pushSample();
        return items;
      }

      if (ctx === "well") {
        if (well) {
          items.push({
            title: `Well: ${well}`,
            href: this.appendRouteQuery(
              `/${tenantId}/qaqc/detail/${encodeURIComponent(well)}`,
              listQ
            ),
          });
        }
        pushSample();
        return items;
      }

      if (well) {
        items.push({
          title: `Well: ${well}`,
          href: this.appendRouteQuery(
            `/${tenantId}/qaqc/detail/${encodeURIComponent(well)}`,
            listQ
          ),
        });
      }
      pushSample();
      return items;
    },
    async ensureQaqcBreadcrumbSampleMeta() {
      const path = this.$route.path || "";
      if (!path.includes("/qaqc/test/")) return;

      const mongoId = this.$route.params?.sampleId;
      if (!mongoId) return;

      const ctx = this.parseQaqcNavContext(this.$route);
      const well = this.parseQaqcWellFromRoute(this.$route);
      const fluidSampleId = this.parseQaqcFluidSampleIdFromRoute(this.$route);
      const needsWell = ctx === "well" || ctx === "direct";
      if (fluidSampleId && (!needsWell || well)) return;

      if (this.qaqcBreadcrumbMetaSampleId === mongoId && this.qaqcBreadcrumbSampleMeta) {
        return;
      }
      if (this.isLoadingQaqcBreadcrumbMeta) return;

      const pathSegments = path.split("/").filter(Boolean);
      const tenantId = pathSegments[0] || "";
      if (!tenantId) return;

      this.isLoadingQaqcBreadcrumbMeta = true;
      try {
        const response = await axios.get(
          process.env.VUE_APP_API_URL + `public/api/samples/${mongoId}?viewSummary=true`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              "X-TenantID": tenantId,
            },
          }
        );
        const payload = response?.data?.data;
        const sample =
          payload?.sample && typeof payload.sample === "object"
            ? payload.sample
            : payload;
        if (!sample) return;

        const resolvedWell =
          sample.location?.well ?? sample.wellName ?? sample.well ?? "";
        const resolvedFluid =
          sample.fluidSampleID ?? sample.FluidSampleID ?? "";

        this.qaqcBreadcrumbSampleMeta = {
          well: String(resolvedWell || ""),
          fluidSampleID: String(resolvedFluid || ""),
        };
        this.qaqcBreadcrumbMetaSampleId = mongoId;
        this.$forceUpdate();
      } catch {
        void 0;
      } finally {
        this.isLoadingQaqcBreadcrumbMeta = false;
      }
    },
    formatQaqcTestBreadcrumbTitle(title) {
      if (!title) return title;
      return String(title).replace(/([^\s])\(/g, "$1 (");
    },
    buildQaqcTestBreadcrumbTitle(routeTestType, routeTestId) {
      const plural = routeTestType.toLowerCase().replace(/test$/, "tests");
      let title = this.displayTestType(plural) || routeTestType;

      if (routeTestId && this.allTests?.length) {
        const currentTest = this.allTests.find((test) => {
          const testTestType = test.testType || test.TestType || test.test_type;
          const normalizedRouteTestType = routeTestType.toLowerCase().replace(/test$/, "tests");
          const testTypeMatch =
            testTestType === routeTestType ||
            testTestType === normalizedRouteTestType ||
            testTestType === routeTestType.replace(/s$/, "");
          const idMatch =
            (test.ID || test.id || test.testId) === routeTestId ||
            (test.ID || test.id || test.testId) === String(routeTestId);
          return testTypeMatch && idMatch;
        });

        if (currentTest) {
          if (this.getTestType(currentTest) === "compositiontests") {
            const parts = [];
            if (currentTest.contaminationType) {
              parts.push(
                currentTest.contaminationType.charAt(0).toUpperCase() +
                  currentTest.contaminationType.slice(1)
              );
            }
            if (currentTest.recombinationType) {
              parts.push(
                currentTest.recombinationType.charAt(0).toUpperCase() +
                  currentTest.recombinationType.slice(1)
              );
            }
            const base = this.getTestDisplayName(this.getTestType(currentTest), currentTest);
            title = parts.length ? `${base} (${parts.join(" ")})` : base;
          } else {
            title = this.getTestDisplayName(this.getTestType(currentTest), currentTest);
            if (currentTest.testTemperature != null || currentTest.testTemperature_UOM) {
              const uom = currentTest.testTemperature_UOM || "";
              const tempPart = uom
                ? `${currentTest.testTemperature} ${uom}`
                : `${currentTest.testTemperature}`;
              const base = title.replace(/\s*\([^)]*\)\s*$/, "").trim();
              title = `${base} (${tempPart})`;
            }
          }
        }
      }

      return title;
    },
    showSnackbar(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
    goToAssets() {
      const lastView = localStorage.getItem("activeMenu");
      const urlSegments = window.location.pathname.split("/").filter(Boolean);
      const tenantId = urlSegments.length > 0 ? urlSegments[0] : (getTenantPrefix() || "");

      if (!tenantId) {
        return;
      }

      const isQaqcRoute = urlSegments[1] && urlSegments[1].toLowerCase() === "qaqc";
      if (isQaqcRoute) {
        const path = `/${tenantId}/qaqc/overview`;
        const onQaqcTest =
          urlSegments[2]?.toLowerCase() === "test" && urlSegments.length >= 5;
        const query = onQaqcTest
          ? mergeOverviewTabIntoQuery(
              pickSamplesListQueryForRouter(this.$route.query || {}),
              overviewTabFromTestRoute(this.$route)
            )
          : pickSamplesListQueryForRouter(this.$route.query || {});
        this.$router.push({ path, query });
        return;
      }

      if (lastView && lastView.toLowerCase() === "data management") {
        this.$router.push(`/${tenantId}/data-management`);
      }
      else if (lastView && lastView.toLowerCase() === "qa/qc") {
        this.$router.push(`/${tenantId}/qaqc`);
      }
      else if (lastView && lastView === "QA/QC Overview") {
        const query = pickSamplesListQueryForRouter(this.$route.query || {});
        this.$router.push({ path: `/${tenantId}/qaqc/overview`, query });
      }
      else if (urlSegments[1] && urlSegments[1].toLowerCase() === "assets") {
        this.$router.push(`/${tenantId}/assets`);
      }
    },
    updateBreadcrumbs() {
      const currentURL = window.location.pathname;
      this.currentURLSegments = currentURL
        .split("/")
        .filter((segment) => segment !== "");
      let updatedPath = `/${this.currentURLSegments.join("/")}`;
      updatedPath = updatedPath.replace(/\/$/, "");
      window.history.replaceState({}, "", updatedPath);
    },
    toggleTestsDropdown(event) {
      event.stopPropagation();
      this.showTestsDropdown = !this.showTestsDropdown;
      
      if (this.showTestsDropdown) {
        if (!this.allTests || this.allTests.length === 0) {
          this.showTests();
        }
      }
    },
    showTests() {
      const pathSegments = this.$route.path.split('/').filter(Boolean);
      const tenantId = pathSegments[0] || '';
      const currentRoute = `/${pathSegments.slice(1).join('/')}`;
      const isAssetsTestRoute = currentRoute.includes("/assets/") && (
        currentRoute.includes("/dltest") || currentRoute.includes("/ccetest") ||
        currentRoute.includes("/cvdtest") || currentRoute.includes("/separatortest") ||
        currentRoute.includes("/viscositytest") || currentRoute.includes("/compositiontests")
      );
      const isQaqcUnifiedTestRoute = currentRoute.includes("/qaqc/test/");
      let sampleId = null;
      if (isAssetsTestRoute || isQaqcUnifiedTestRoute) {
        sampleId = this.$route.params.sampleId;
      }

      if (!sampleId) {
        return;
      }
      if (this.isLoadingTests) {
        return;
      }

      this.isTestAvailable = false;
      this.isLoadingTests = true;

      axios
        .get(process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}/tests`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "X-TenantID": tenantId,
          },
        })
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            let tests = [];
            const data = response.data.data;
            
            if (data) {
              this.isTestAvailable = data.IsTestAvailable === true || data.isTestAvailable === true;
              if (Array.isArray(data.compositiontests) && data.compositiontests.length > 0) {
                data.compositiontests.forEach((test, idx) => {
                  tests.push({
                    ...test,
                    testType: 'compositiontests',
                    TestType: 'compositiontests',
                    test_type: 'compositiontests',
                    ID: test.ID || test.id || test._id,
                    id: test.ID || test.id || test._id,
                    index: idx
                  });
                });
              }
              if (Array.isArray(data.ccetests) && data.ccetests.length > 0) {
                data.ccetests.forEach((test, idx) => {
                  tests.push({
                    ...test,
                    testType: 'ccetests',
                    TestType: 'ccetests',
                    test_type: 'ccetests',
                    ID: test.ID || test.id || test._id,
                    id: test.ID || test.id || test._id,
                    index: idx
                  });
                });
              }
              if (Array.isArray(data.dltests) && data.dltests.length > 0) {
                data.dltests.forEach((test, idx) => {
                  tests.push({
                    ...test,
                    testType: 'dltests',
                    TestType: 'dltests',
                    test_type: 'dltests',
                    ID: test.ID || test.id || test._id,
                    id: test.ID || test.id || test._id,
                    index: idx
                  });
                });
              }
              if (Array.isArray(data.cvdtests) && data.cvdtests.length > 0) {
                data.cvdtests.forEach((test, idx) => {
                  tests.push({
                    ...test,
                    testType: 'cvdtests',
                    TestType: 'cvdtests',
                    test_type: 'cvdtests',
                    ID: test.ID || test.id || test._id,
                    id: test.ID || test.id || test._id,
                    index: idx
                  });
                });
              }
              if (Array.isArray(data.viscositytests) && data.viscositytests.length > 0) {
                data.viscositytests.forEach((test, idx) => {
                  tests.push({
                    ...test,
                    testType: 'viscositytests',
                    TestType: 'viscositytests',
                    test_type: 'viscositytests',
                    ID: test.ID || test.id || test._id,
                    id: test.ID || test.id || test._id,
                    index: idx
                  });
                });
              }
              if (Array.isArray(data.separatortests) && data.separatortests.length > 0) {
                data.separatortests.forEach((test, idx) => {
                  tests.push({
                    ...test,
                    testType: 'separatortests',
                    TestType: 'separatortests',
                    test_type: 'separatortests',
                    ID: test.ID || test.id || test._id,
                    id: test.ID || test.id || test._id,
                    index: idx
                  });
                });
              }
            }
            
            if (tests.length === 0 && Array.isArray(data.allTests) && data.allTests.length > 0) {
              const firstItem = data.allTests[0];
              const isEmpty = !firstItem || Object.keys(firstItem).length === 0;
              
              if (isEmpty) {
                axios
                  .get(process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}`, {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                      "X-TenantID": tenantId,
                    },
                  })
                  .then((sampleResponse) => {
                    if (sampleResponse && sampleResponse.data && 
                        (sampleResponse.data.statusCode === 200 || sampleResponse.data.statusCode === 201)) {
                      const sampleData = sampleResponse.data.data;
                      
                      if (sampleData) {
                        const actualSampleData = sampleData.sample || sampleData;
                        this.isTestAvailable = actualSampleData.IsTestAvailable === true || actualSampleData.isTestAvailable === true;
                        this.processSampleDataForTests(actualSampleData, sampleId);
                        return;
                      }
                    }
                  })
                  .catch((error) => {
                    void 0;
                  });
                return;
              } else {
                tests = data.allTests.map((test, idx) => {
                  const testId = test.ID || test.id || test._id || test.testId;
                  return {
                    ...test,
                    testType: test.testType || test.TestType || test.test_type || 'unknown',
                    TestType: test.TestType || test.testType || test.test_type || 'unknown',
                    test_type: test.test_type || test.testType || test.TestType || 'unknown',
                    ID: testId,
                    id: testId,
                    testId: testId,
                    index: test.index !== undefined ? test.index : idx
                  };
                });
              }
            }
            
            if (tests.length > 0) {
              const validTests = tests.filter(test => {
                if (!test) return false;
                const isSampleValidation = (test.testType === 'sampleValidation' || 
                                           test.TestType === 'sampleValidation' || 
                                           test.test_type === 'sampleValidation' ||
                                           test.type === 'Sample Validation');
                return !isSampleValidation;
              });

              const testGroups = {};
              validTests.forEach(test => {
                let testType = test.testType || test.TestType || test.test_type;
                
                if (!testType) {
                  if (test.compositiontests || test.type === 'Composition') {
                    testType = 'compositiontests';
                  } else if (test.ccetests || test.type === 'CCE Test') {
                    testType = 'ccetests';
                  } else if (test.dltests || test.type === 'DL Test') {
                    testType = 'dltests';
                  } else if (test.cvdtests || test.type === 'CVD Test') {
                    testType = 'cvdtests';
                  } else if (test.viscositytests || test.type === 'Viscosity Test') {
                    testType = 'viscositytests';
                  } else if (test.separatortests || test.type === 'Separator Test') {
                    testType = 'separatortests';
                  } else if (test.type === 'Sample Validation') {
                    testType = 'sampleValidation';
                  } else {
                    testType = 'unknown';
                  }
                  
                  test.testType = testType;
                  test.TestType = testType;
                  test.test_type = testType;
                }
                
                if (!testGroups[testType]) {
                  testGroups[testType] = [];
                }
                testGroups[testType].push(test);
              });

              this.assignPerTypeTestMetadata(testGroups);
              Object.keys(testGroups).forEach((testType) => {
                const group = testGroups[testType];
                group.forEach((test) => {
                  test.index = group.length > 1 ? test.testIndex + 1 : 0;
                });
              });

              const finalTestsFromMain = [].concat(...Object.values(testGroups));
              this.allTests.splice(0, this.allTests.length, ...finalTestsFromMain);
              this.$nextTick(() => {
                this.$forceUpdate();
              });
            } else {
              this.isTestAvailable = false;
            }
          }
          else if (response && response.data && response.data.message) {
            this.showSnackbar(response.data.message, "error");
          }
          else {
            this.showSnackbar("Error in fetching tests", "error");
          }
        })
        .catch((error) => {
          if (error.response) {
            void 0;
          }
        })
        .finally(() => {
          this.isLoadingTests = false;
        });
    },

    processSampleDataForTests(sampleData, sampleId) {
      let tests = [];
      
      if (Array.isArray(sampleData.compositiontests) && sampleData.compositiontests.length > 0) {
        sampleData.compositiontests.forEach((test, index) => {
          const testId = test.ID || test._id || test.id;
          tests.push({
            type: 'Composition',
            testType: 'compositiontests',
            TestType: 'compositiontests',
            test_type: 'compositiontests',
            testId: testId,
            ID: testId,
            id: testId,
            testData: test,
            index: index,
            contaminationType: test.contaminationType,
            recombinationType: test.recombinationType,
            testTemperature: test.testTemperature,
            testTemperature_UOM: test.testTemperature_UOM
          });
        });
      }
      
      if (Array.isArray(sampleData.ccetests) && sampleData.ccetests.length > 0) {
        sampleData.ccetests.forEach((test, index) => {
          const testId = test.ID || test._id || test.id;
          tests.push({
            type: 'CCE Test',
            testType: 'ccetests',
            TestType: 'ccetests',
            test_type: 'ccetests',
            testId: testId,
            ID: testId,
            id: testId,
            testData: test,
            index: index,
            testTemperature: test.testTemperature,
            testTemperature_UOM: test.testTemperature_UOM
          });
        });
      }
      
      if (Array.isArray(sampleData.dltests) && sampleData.dltests.length > 0) {
        sampleData.dltests.forEach((test, index) => {
          const testId = test.ID || test._id || test.id;
          tests.push({
            type: 'DL Test',
            testType: 'dltests',
            TestType: 'dltests',
            test_type: 'dltests',
            testId: testId,
            ID: testId,
            id: testId,
            testData: test,
            index: index,
            testTemperature: test.testTemperature,
            testTemperature_UOM: test.testTemperature_UOM
          });
        });
      }
      
      if (Array.isArray(sampleData.cvdtests) && sampleData.cvdtests.length > 0) {
        sampleData.cvdtests.forEach((test, index) => {
          const testId = test.ID || test._id || test.id;
          tests.push({
            type: 'CVD Test',
            testType: 'cvdtests',
            TestType: 'cvdtests',
            test_type: 'cvdtests',
            testId: testId,
            ID: testId,
            id: testId,
            testData: test,
            index: index,
            testTemperature: test.testTemperature,
            testTemperature_UOM: test.testTemperature_UOM
          });
        });
      }
      
      if (Array.isArray(sampleData.viscositytests) && sampleData.viscositytests.length > 0) {
        sampleData.viscositytests.forEach((test, index) => {
          const testId = test.ID || test._id || test.id;
          tests.push({
            type: 'Viscosity Test',
            testType: 'viscositytests',
            TestType: 'viscositytests',
            test_type: 'viscositytests',
            testId: testId,
            ID: testId,
            id: testId,
            testData: test,
            index: index,
            testTemperature: test.testTemperature,
            testTemperature_UOM: test.testTemperature_UOM
          });
        });
      }
      
      if (Array.isArray(sampleData.separatortests) && sampleData.separatortests.length > 0) {
        sampleData.separatortests.forEach((test, index) => {
          const testId = test.ID || test._id || test.id;
          tests.push({
            type: 'Separator Test',
            testType: 'separatortests',
            TestType: 'separatortests',
            test_type: 'separatortests',
            testId: testId,
            ID: testId,
            id: testId,
            testData: test,
            index: index,
            testTemperature: test.testTemperature,
            testTemperature_UOM: test.testTemperature_UOM
          });
        });
      }
      
      const validTests = tests.filter(test => {
        if (!test) return false;
        const isSampleValidation = (test.testType === 'sampleValidation' || 
                                   test.TestType === 'sampleValidation' || 
                                   test.test_type === 'sampleValidation' ||
                                   test.type === 'Sample Validation');
        return !isSampleValidation;
      });
      
      const testGroups = {};
      validTests.forEach(test => {
        const testType = test.testType || test.TestType || test.test_type || 'unknown';
        if (!testGroups[testType]) {
          testGroups[testType] = [];
        }
        testGroups[testType].push(test);
      });
      
      this.assignPerTypeTestMetadata(testGroups);
      Object.keys(testGroups).forEach((testType) => {
        const group = testGroups[testType];
        group.forEach((test) => {
          test.index = group.length > 1 ? test.testIndex + 1 : 0;
        });
      });

      const finalTests = [].concat(...Object.values(testGroups));
      this.allTests.splice(0, this.allTests.length, ...finalTests);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    getTestType(test) {
      return test?.testType || test?.TestType || test?.test_type || 'unknown';
    },
    assignPerTypeTestMetadata(testGroups) {
      if (!testGroups) return;
      Object.keys(testGroups).forEach((testType) => {
        const group = testGroups[testType];
        const groupLen = group.length;
        group.forEach((test, testIndex) => {
          test.testIndex = testIndex;
          test.sameTypeTestCount = groupLen;
        });
      });
    },
    getTestDisplayName(testType, test) {
      if (!testType || testType === 'unknown') {
        return 'Unknown Test';
      }
      const testTypeDisplay = this.displayTestType(testType);
      const sameTypeCount = test?.sameTypeTestCount;
      const testIndex = test?.testIndex;
      if (
        typeof sameTypeCount === 'number' &&
        sameTypeCount > 1 &&
        typeof testIndex === 'number' &&
        testIndex >= 0
      ) {
        return `${testTypeDisplay} (Test #${testIndex + 1})`;
      }
      return testTypeDisplay;
    },

    pluralTestTypeToAssetRouteSegment(testType) {
      const map = {
        compositiontests: "compositiontests",
        ccetests: "ccetest",
        dltests: "dltest",
        cvdtests: "cvdtest",
        separatortests: "separatortest",
        viscositytests: "viscositytest",
      };
      return map[testType] || testType;
    },
    openTestPage(test, index) {
      this.setActiveTestIndex(index);
      this.showTestsDropdown = false;

      const routeSampleId = this.$route.params.sampleId;
      const testId = test.ID || test.id;
      const rawTestType = this.getTestType(test);
      const assetRouteSegment = this.pluralTestTypeToAssetRouteSegment(rawTestType);

      const pathSegments = this.$route.path.split('/').filter(Boolean);
      const tenantId = pathSegments[0] || '';
      const currentRoute = `/${pathSegments.slice(1).join('/')}`;
      
      if (currentRoute.includes("/qaqc")) {
        if (!routeSampleId) return;
        const testPath = `/${tenantId}/qaqc/test/${routeSampleId}/${rawTestType}/${testId}`;
        const newRoute = this.appendRouteQuery(testPath, pickSamplesListQueryForRouter(this.$route.query || {}));
        localStorage.setItem("lastView", newRoute);
        this.$router.push(newRoute);
      } else {
        const routeParams = { ...this.$route.params };
        const encodeSeg = (v) => (v ? encodeURIComponent(v).replace(/'/g, "%27").replace(/ /g, "-") : "");
        const sid = routeSampleId ? encodeSeg(routeSampleId) : "";
        const assetSeg = encodeSeg(routeParams.asset);
        const fieldSeg = encodeSeg(routeParams.field);
        const wellSeg = encodeSeg(routeParams.well);
        if (!sid) return;
        let newRoute = `/${tenantId}/assets/${assetSeg}/${fieldSeg}/${wellSeg}/${sid}/${assetRouteSegment}/${testId}`;
        localStorage.setItem("lastView", newRoute);
        this.$router.push(newRoute);
      }
    },

    openSampleValidationPage() {
      this.showTestsDropdown = false;

      const routeSampleId = this.$route.params.sampleId;

      const pathSegments = this.$route.path.split('/').filter(Boolean);
      const tenantId = pathSegments[0] || '';
      const currentRoute = `/${pathSegments.slice(1).join('/')}`;
      
      if (currentRoute.includes("/qaqc")) {
        const w = this.$route.params.well;
        const detailBase =
          w != null && String(w).trim() !== ""
            ? `/${tenantId}/qaqc/detail/${encodeURIComponent(String(w))}`
            : `/${tenantId}/qaqc/detail`;
        const newRoute = this.appendRouteQuery(
          detailBase,
          pickSamplesListQueryForRouter(this.$route.query || {})
        );
        localStorage.setItem("lastView", newRoute);
        this.$router.push(newRoute);
      } else {
        if (!routeSampleId) return;
        const routeParams = { ...this.$route.params };
        let newRoute = `/${tenantId}/assets/${routeParams.asset ? routeParams.asset.replace(/\//g, '-').replace(/ /g, '-') : ''}/${routeParams.field ? routeParams.field.replace(/\//g, '-').replace(/ /g, '-') : ''}/${routeParams.well ? routeParams.well.replace(/\//g, '-').replace(/ /g, '-') : ''}/samplevalidation/${routeSampleId}`;
        localStorage.setItem("lastView", newRoute);
        this.$router.push(newRoute);
      }
    },
    closeDropdownMenuOnClickOutside(event) {
      if (this.showTestsDropdown) {
        if (this.$refs.dropdownMenu && !this.$refs.dropdownMenu.contains(event.target)) {
          this.showTestsDropdown = false;
        }
      }
    },
    isNonNavBreadcrumbItem(item) {
      if (item?.nonNav === true) {
        return true;
      }
      const t = item?.title;
      return (
        t === "Exploratory Data Analysis (EDA)" ||
        t === "Sample Details" ||
        t === "Tests"
      );
    },
    handleBreadcrumb(title) {
      if (title === "Dashboards") {
        localStorage.removeItem("lastVisitedDashboard");
      } 
    },
    handleStorageChange(event) {
      if (event.key === "sampleId") {
        this.allTests = [];
        this.$forceUpdate();
      }
    },
    handleSampleIdChange() {
      this.currentSampleId = this.$route.params.sampleId || null;
      this.allTests = [];
      this.$forceUpdate();
    }
  },
    watch: {
    $route(to, from) {
      this.updateBreadcrumbs();
      const newSampleId = to.params.sampleId ?? null;
      if (this.currentSampleId !== newSampleId) {
        this.currentSampleId = newSampleId;
        this.allTests = [];
        this.qaqcBreadcrumbSampleMeta = null;
        this.qaqcBreadcrumbMetaSampleId = null;
      }
      if (to.path?.includes("/qaqc/test/")) {
        this.ensureQaqcBreadcrumbSampleMeta();
      }
    },
    breadcrumbItems: {
      handler(newItems, oldItems) {
        const containsTestType = newItems.some(item => item.isTestType === true);
        if (containsTestType && (!this.allTests || this.allTests.length === 0)) {
          this.showTests();
        }
        if (containsTestType) {
          this.ensureQaqcBreadcrumbSampleMeta();
        }
      },
      deep: true,
      immediate: true
    },
  },
  mounted() {
    document.body.addEventListener("click", this.closeDropdownMenuOnClickOutside);
    this.currentSampleId = this.$route.params.sampleId ?? null;
    this.updateBreadcrumbs();
    if (this.$route.path?.includes("/qaqc/test/")) {
      this.ensureQaqcBreadcrumbSampleMeta();
    }
    window.addEventListener("storage", this.handleStorageChange);
    window.addEventListener("sampleIdChanged", this.handleSampleIdChange);
  },
  beforeUnmount() {
    document.body.removeEventListener("click", this.closeDropdownMenuOnClickOutside);
    window.removeEventListener("storage", this.handleStorageChange);
    window.removeEventListener("sampleIdChanged", this.handleSampleIdChange);
  },
};
</script>